const SET_INCIDENT = 'SET_INCIDENT';
const SET_INCIDENT_STATS = 'SET_INCIDENT_STATS';
const SET_INCIDENT_FIELDS = 'SET_INCIDENT_FIELDS';
const SET_INCIDENT_HISTORY_FIELDS = 'SET_INCIDENT_HISTORY_FIELDS';
const SET_INCIDENT_209_RESOURCES_FIELDS = 'SET_INCIDENT_209_RESOURCES_FIELDS';
const CLEAR_INCIDENT = 'CLEAR_INCIDENT';
const SET_INITIAL_INCIDENT_FILTER = 'SET_INITIAL_INCIDENT_FILTER';
const UPDATE_INCIDENT_FILTER_VALUES = 'UPDATE_INCIDENT_FILTER_VALUES';
const UPDATE_INCIDENT_SQL_FILTER = 'UPDATE_INCIDENT_SQL_FILTER';
const CLEAR_INCIDENT_FILTERS = 'CLEAR_INCIDENT_FILTERS';

const SET_INITIAL_INCIDENT_LIST_COLUMNS = 'SET_INITIAL_INCIDENT_LIST_COLUMNS';
const ADD_INCIDENT_LIST_COLUMN = 'ADD_INCIDENT_LIST_COLUMN';
const REMOVE_INCIDENT_LIST_COLUMN = 'REMOVE_INCIDENT_LIST_COLUMN';

const SET_INITIAL_INCIDENT_RESOURCE_LIST_COLUMNS =
  'SET_INITIAL_INCIDENT_RESOURCE_LIST_COLUMNS';
const ADD_INCIDENT_RESOURCE_LIST_COLUMN = 'ADD_INCIDENT_RESOURCE_LIST_COLUMN';
const REMOVE_INCIDENT_RESOURCE_LIST_COLUMN =
  'REMOVE_INCIDENT_RESOURCE_LIST_COLUMN';

const SET_INITIAL_INCIDENT_EXPERIENCE_LIST_COLUMNS =
  'SET_INITIAL_INCIDENT_EXPERIENCE_LIST_COLUMNS';
const ADD_INCIDENT_EXPERIENCE_LIST_COLUMN =
  'ADD_INCIDENT_EXPERIENCE_LIST_COLUMN';
const REMOVE_INCIDENT_EXPERIENCE_LIST_COLUMN =
  'REMOVE_INCIDENT_EXPERIENCE_LIST_COLUMN';

const SET_INITIAL_INCIDENT_REQUEST_LIST_COLUMNS =
  'SET_INITIAL_INCIDENT_REQUEST_LIST_COLUMNS';
const ADD_INCIDENT_REQUEST_LIST_COLUMN = 'ADD_INCIDENT_REQUEST_LIST_COLUMN';
const REMOVE_INCIDENT_REQUEST_LIST_COLUMN =
  'REMOVE_INCIDENT_REQUEST_LIST_COLUMN';

const SET_HISTORY_LOADING = 'SET_HISTORY_LOADING';
const SET_HISTORY_INCIDENTS = 'SET_HISTORY_INCIDENTS';
const SET_HISTORY_IS_MORE = 'SET_HISTORY_IS_MORE';
const SET_HISTORY_INCIDENT_COUNT = 'SET_HISTORY_INCIDENT_COUNT';
const SET_HISTORY_SHOW_DATA_GRID = 'SET_HISTORY_SHOW_DATA_GRID';

export default {
  SET_INCIDENT,
  SET_INCIDENT_STATS,
  SET_INCIDENT_FIELDS,
  SET_INCIDENT_HISTORY_FIELDS,
  SET_INCIDENT_209_RESOURCES_FIELDS,
  CLEAR_INCIDENT,
  SET_INITIAL_INCIDENT_FILTER,
  UPDATE_INCIDENT_FILTER_VALUES,
  UPDATE_INCIDENT_SQL_FILTER,
  CLEAR_INCIDENT_FILTERS,
  SET_INITIAL_INCIDENT_LIST_COLUMNS,
  ADD_INCIDENT_LIST_COLUMN,
  REMOVE_INCIDENT_LIST_COLUMN,
  SET_INITIAL_INCIDENT_RESOURCE_LIST_COLUMNS,
  ADD_INCIDENT_RESOURCE_LIST_COLUMN,
  REMOVE_INCIDENT_RESOURCE_LIST_COLUMN,
  SET_INITIAL_INCIDENT_REQUEST_LIST_COLUMNS,
  ADD_INCIDENT_REQUEST_LIST_COLUMN,
  REMOVE_INCIDENT_REQUEST_LIST_COLUMN,
  SET_INITIAL_INCIDENT_EXPERIENCE_LIST_COLUMNS,
  ADD_INCIDENT_EXPERIENCE_LIST_COLUMN,
  REMOVE_INCIDENT_EXPERIENCE_LIST_COLUMN,
  SET_HISTORY_LOADING,
  SET_HISTORY_INCIDENTS,
  SET_HISTORY_IS_MORE,
  SET_HISTORY_INCIDENT_COUNT,
  SET_HISTORY_SHOW_DATA_GRID
};



// WEBPACK FOOTER //
// ./src/redux/incident/types.js